import { StyleSheet } from 'aphrodite'

import item from './item'
import list from './list'
import status from './status'
import ColorBlind from './ColorBlind'

export default {
  list: StyleSheet.create(list),
  item: StyleSheet.create(item),
  status: StyleSheet.create(status),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/RevenueTable/style/index.js